export const getAnnuityFactor = (monthlyRate: number, months: number): number =>
	(1 - (1 + monthlyRate) ** -months) / monthlyRate;
